import React from 'react';
import { useDropzone } from 'react-dropzone';

function DropzoneCompo({ onFilesAccepted }) {
  const { getRootProps, getInputProps } = useDropzone({
    multiple: true,
    onDrop: (acceptedFiles) => {
      if (typeof onFilesAccepted === 'function') {
        onFilesAccepted(acceptedFiles);
      }
    },
  });

  return (
    <div
      {...getRootProps({ className: 'dropzone' })}
      className="dropzone border-2 border-dashed border-gray-400 rounded-md p-4 text-center"
    >
      <input {...getInputProps()} />
      <p className="text-gray-600">
        Drag 'n' drop any files here, or click to select files
      </p>
    </div>
  );
}

export default DropzoneCompo;